export default __webpack_public_path__ + "static/lily-fab501d70360a641e2e31d9a2a292b88.png";